import classNames from 'classnames';
import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { Divider, Toggle } from 'rsuite';
import { InputBox } from '../../../../../components';
import { ChannelsConfigSchema } from '../../../../../reducers/reducerIPA/channels';
import { SetupIPAOption } from '../SetupIPA';
import containerStyles from '../SetupIPA/SetupIPA.module.scss';
import styles from './SetupIpaChannels.module.scss';

type SetupWholesaleFormProps = { form: UseFormReturn<ChannelsConfigSchema> };

export const SetupWholesaleForm = ({ form }: SetupWholesaleFormProps) => {
  return (
    <div className={styles.wrapper}>
      <div>
        <h3 className={containerStyles['section-title']}>Preço atacado</h3>
        <p className={classNames(containerStyles['setup-ipa__header__subtitle'], styles['header-subtitle'])}>
          Habilitar e definir as configurações para a precificação no atacado
        </p>
      </div>

      <div className={styles['toggle-container']}>
        <Controller
          control={form.control}
          name="wholesale.enabled"
          render={({ field: { value, ...field } }) => <Toggle size="sm" checked={value} {...field} />}
        />
        <span>
          <h5 className={styles['toggle-container__title']}>Usar o preço de atacado no IPA</h5>
          <p className={styles['toggle-container__subtitle']}>Defina a estratégia e gerencie o preço de atacado diretamente no IPA</p>
        </span>
      </div>

      {!!form.watch('wholesale.enabled') && (
        <>
          <Divider />

          <SetupIPAOption title="preço psicológico" subtitle="Defina se o preço de atacado deve ser arredondado segundo o preço psicológico ou não.">
            <Controller
              control={form.control}
              name="wholesale.allowPriceRound"
              render={({ field, fieldState: { error } }) => (
                <InputBox>
                  <InputBox.RadioGroup {...field}>
                    <InputBox.Radio value={true}>Arredondar o preço de atacado usando preço psicológico</InputBox.Radio>
                    <InputBox.Radio value={false}>Manter o preço de atacado sem arredondamento</InputBox.Radio>
                  </InputBox.RadioGroup>
                  <InputBox.Error message={error?.message} />
                </InputBox>
              )}
            />
          </SetupIPAOption>

          <Divider />

          <SetupIPAOption
            title="edição no gerenciador de preços"
            subtitle="Escolha se os usuários poderão ou não editar o preço de atacado sugerido no gerenciador de preços e o gatilho de ativação."
          >
            <Controller
              control={form.control}
              name="wholesale.allowPriceEdit"
              render={({ field: { value, ...field }, fieldState: { error } }) => (
                <InputBox>
                  <InputBox.Check checked={value} {...field}>
                    <h5 className={styles['toggle-container__title']}>Permitir a edição do preço de atacado</h5>
                    <p className={styles['toggle-container__subtitle']}>
                      Essa opção possibilita que o usuário altere o preço de atacado sugerido, seja pelo valor, pela margem ou pela competitividade.
                    </p>
                  </InputBox.Check>
                  <InputBox.Error message={error?.message} />
                </InputBox>
              )}
            />

            <Controller
              control={form.control}
              name="wholesale.allowTriggerEdit"
              render={({ field: { value, ...field }, fieldState: { error } }) => (
                <InputBox>
                  <InputBox.Check checked={value} {...field}>
                    <h5 className={styles['toggle-container__title']}>Permitir a edição do gatilho de ativação do preço de atacado</h5>
                    <p className={styles['toggle-container__subtitle']}>
                      Possibilita a edição do gatilho que ativa o preço de atacado diretamente na tela de gerenciador de preços.
                    </p>
                  </InputBox.Check>
                  <InputBox.Error message={error?.message} />
                </InputBox>
              )}
            />
          </SetupIPAOption>
        </>
      )}
    </div>
  );
};
